import { CHROME_EXTENSION_URL } from '@/lib/constants'
import { LogoMark } from './Logo'

// Promo strip for the Chrome extension. Pitches the benefit (use Promptioso *inside* Suno's
// Create page, no copy-paste) at the moment intent peaks — under the Style editor, right
// next to "Copy for Suno". Installing/opening it needs no account; the AI features prompt
// sign-in inside the extension panel.
export default function ExtensionCallout({ href = CHROME_EXTENSION_URL }: { href?: string }) {
  return (
    <div className="flex flex-col items-start gap-4 rounded-2xl border border-primary-900/60 bg-gradient-to-br from-primary-950/40 to-gray-900 p-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <LogoMark size="md" />
        <div>
          <div className="font-semibold text-gray-100">Use Promptioso inside Suno</div>
          <p className="text-sm text-gray-400">
            Improve your Style prompt and drop it straight into the Create page — no copy-paste.
          </p>
        </div>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="btn-primary whitespace-nowrap px-5 py-2 text-sm"
      >
        Add to Chrome — Free
      </a>
    </div>
  )
}
